/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Coin } from './Coin';
import {
    CoinFromJSON,
    CoinFromJSONTyped,
    CoinToJSON,
} from './Coin';

/**
 * 
 * @export
 * @interface CoinResponse
 */
export interface CoinResponse {
    /**
     * 
     * @type {Coin}
     * @memberof CoinResponse
     */
    data?: Coin;
}

/**
 * Check if a given object implements the CoinResponse interface.
 */
export function instanceOfCoinResponse(value: object): value is CoinResponse {
    let isInstance = true;

    return isInstance;
}

export function CoinResponseFromJSON(json: any): CoinResponse {
    return CoinResponseFromJSONTyped(json, false);
}

export function CoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CoinFromJSON(json['data']),
    };
}

export function CoinResponseToJSON(value?: CoinResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CoinToJSON(value.data),
    };
}

